import { useStakingProvider } from '@trustpad/launchpad/dist/staking/hooks/useStaking';

import * as React from 'react';
import { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

import { Countdown } from '~common/Countdown';

import { getStakingSymbol, getStakingTokens } from '../../utils';
import { AdminPanel } from '../AdminPanel';
import { StakingStats } from '../StakingStats';
import { TokenImage } from '../TokenImage';
import { ActionsCard } from './ActionsCard';
import { StakingTitle } from './StakingTitle';

export function StakingCard() {
  const { pool } = useStakingProvider();
  const [collapsed, setCollapsed] = useState(true);
  const [mainToken, secondToken] = getStakingTokens(pool);

  return (
    <div className="overflow-hidden">
      <div
        className={`px-6 py-3 bg-dark1 bg-opacity-80 border-dark1 shadow-2xl cursor-pointer ${
          collapsed ? 'rounded-lg' : 'rounded-t-lg'
        }`}
        onClick={() => setCollapsed(!collapsed)}>
        <div className="flex items-center flex-col md:flex-row">
          <div className="mr-3">
            <TokenImage
              imageSrc={mainToken.imageSrc}
              symbol={mainToken.symbol}
              secondImageSrc={secondToken?.imageSrc}
            />
          </div>

          <div className="space-y-3">
            <StakingTitle pool={pool} />

            {pool.description && (
              <div className="space-y-2">{pool.description()}</div>
            )}

            {pool.deprecated && (
              <div>
                Pool is deprecated, please withdraw the funds and stake in the
                other one.
              </div>
            )}
          </div>

          <div className="ml-auto px-6">
            <button
              onClick={() => setCollapsed(!collapsed)}
              className="text-3xl">
              {collapsed ? <FaChevronDown /> : <FaChevronUp />}
            </button>
          </div>
        </div>

        <div className="mt-3">
          <StakingStats
            priceLabel={secondToken ? 'LP' : mainToken.symbol}
            forceAprZero={pool.deprecated}
          />
        </div>

        <AdminPanel />
      </div>

      <ActionsCard
        collapsed={collapsed}
        symbol={getStakingSymbol(pool)}
        lockDeposit={pool.deprecated}
        lockWithdraw={false}
        deprecated={pool.deprecated}
      />
    </div>
  );
}
